import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"hide-details":"auto","outlined":"","label":_vm.$t('Tracking number')},model:{value:(_vm.trackingNumber),callback:function ($$v) {_vm.trackingNumber=$$v},expression:"trackingNumber"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }